import React, { useState, useEffect } from "react";
import { render } from "react-dom";
import axios from "axios";
import AsyncSelect from "react-select/async";
import { useDispatch, useSelector } from "react-redux";
import { sampleList, coverSampleList } from "../../Store/Actions/SampleActions";
import "./AsyncSelect.scss";

function Async(props) {
  const dispatch = useDispatch();
  const [inputValue, setValue] = useState("");
  const [rand, setRand] = useState("");
  const [error, setError] = useState(null);
  const [selectedValue, setSelectedValue] = useState("");
  const path = window.location.pathname;
  const query = new URLSearchParams(window.location.search);
  const job = query.get("job");
  const jobId = query.get("id");
  const exp = query.get("exp");
  const baseUrl = process.env.REACT_APP_API_URL;
  const resumeJob = useSelector((state) => state.isJobPresent);
  const coverJob = useSelector((state) => state.isCoverJobPresent);
  const local_jobtitle = JSON.parse(localStorage.getItem("user_settings"));
  // handle input change event
  const handleInputChange = (value) => {
    setRand(1);
    setValue(value);
  };

  // handle selection
  const handleChange = (value) => {
    var divElem = document.getElementById("sample-job-select-input");
    var inputElements = divElem.querySelectorAll("input"),
      i;
    for (i = 0; i < inputElements.length; ++i) {
      inputElements[i].blur();
    }
    if (props && props.initial) {
      setSelectedValue(value);
      props.setSelectedValue(value);
    } else {
      setSelectedValue(value);
      if (props && props.cover == "cover") {
        dispatch(coverSampleList(value.job_title));
      } else {
        dispatch(sampleList(value.job_title));
      }
      //   dispatch(sampleList(value.job_title));
    }

    let local_jobtitle = JSON.parse(localStorage.getItem("user_settings"));
    if (local_jobtitle) {
      local_jobtitle.dropdownSelectSample = {
        job_title: value.job_title,
      };
    } else {
      local_jobtitle = {};
      local_jobtitle.dropdownSelectSample = {
        job_title: value.job_title,
      };
    }

    localStorage.setItem("user_settings", JSON.stringify(local_jobtitle));
  };

  useEffect(() => {
    if (job && job) {
      setSelectedValue({ job_title: job, id: job });
      //   dispatch(sampleList(job));
      if (props && props.cover == "cover") {
        dispatch(coverSampleList(job));
      } else {
        dispatch(sampleList(job));
      }
    } else if (props && props.cover == "cover" && coverJob && coverJob.isJob) {
      setSelectedValue({ job_title: coverJob.title, id: coverJob.title });
      dispatch(coverSampleList(coverJob.title));
    } else if (resumeJob && resumeJob.isJob) {
      setSelectedValue({ job_title: resumeJob.title, id: resumeJob.title });
      if (props && props.cover == "cover") {
        dispatch(coverSampleList(resumeJob.title));
      } else {
        dispatch(sampleList(resumeJob.title));
      }
    } else if (
      local_jobtitle &&
      local_jobtitle.accountSettings &&
      local_jobtitle.accountSettings.job_title
    ) {
      setSelectedValue({
        job_title: local_jobtitle.accountSettings.job_title,
        id: local_jobtitle.accountSettings.job_title,
      });
      props.setSelectedValue({
        job_title: local_jobtitle.accountSettings.job_title,
        id: local_jobtitle.accountSettings.job_title,
      });

      if (props && props.cover == "cover") {
        dispatch(coverSampleList(local_jobtitle.accountSettings.job_title));
      } else {
        dispatch(sampleList(local_jobtitle.accountSettings.job_title));
      }
    } else if (local_jobtitle && local_jobtitle.job_title) {
      setSelectedValue({
        job_title: local_jobtitle && local_jobtitle.job_title,
        id: local_jobtitle && local_jobtitle.job_title,
      });
      props.setSelectedValue({
        job_title: local_jobtitle && local_jobtitle.job_title,
        id: local_jobtitle && local_jobtitle.job_title,
      });

      if (props && props.cover == "cover") {
        dispatch(coverSampleList(local_jobtitle && local_jobtitle.job_title));
      } else {
        dispatch(sampleList(local_jobtitle && local_jobtitle.job_title));
      }
    } else {
      if (props && props.initial) {
      } else {
        loadOptions("", "initial");
      }
    }
  }, []);

  // load options using API call
  const loadOptions = (inputValue, isInital) => {
    let url =
      props && props.cover == "cover"
        ? `${baseUrl}/api/sample/cover/jobsListFront?search=${inputValue}`
        : `${baseUrl}/api/sample/jobsListFront?search=${inputValue}`;
    return axios
      .get(url)
      .then((res) => {
        if (isInital == "initial") {
          setSelectedValue(res.data[0]);
          if (props && props.cover == "cover") {
            dispatch(coverSampleList(res.data[0].job_title));
          } else {
            dispatch(sampleList(res.data[0].job_title));
          }
        } else if (job == "All") {
          setSelectedValue(res.data[0]);
        } else if (props && props.initial) {
          setSelectedValue(res.data[0]);
          props.setSelectedValue(res.data[0]);
        }
        return res.data;
      })
      .catch((error) => {
        console.error("API Error:", error);
        setError("No titles available.");
        return [];
      });
  };

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 52,
      minHeight: 52,
      //   backgroundColor: "white",
    }),
    option: (base, { data, isDisabled, isFocused, isSelected }) => ({
      ...base,
      height: 52,
      minHeight: 52,
      color: isFocused ? "white" : "black",
      backgroundColor: isFocused ? "#009b61" : "white",
    }),
  };

  const handleFocus = () => {
    setSelectedValue("");
    // setOptions([]);
  };

  return (
    <div className="App">
      <AsyncSelect
        maxMenuHeight={150}
        placeholder="Search"
        value={selectedValue}
        onFocus={handleFocus}
        getOptionLabel={(e) => e.job_title}
        getOptionValue={(e) => e.id}
        loadOptions={loadOptions}
        onInputChange={handleInputChange}
        onChange={handleChange}
        styles={customStyles}
        id="sample-job-select-input"
        noOptionsMessage={() =>
          error ? (
            <div style={{ color: "red", fontSize: "13px" }}>{error}</div>
          ) : (
            "No options available"
          )
        }
      />
    </div>
  );
}

export default Async;
